import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, HostListener, NgModule } from '@angular/core';
import { ENTER, SPACE, TAB, SEMICOLON } from '@blk/daisy/util';
import { CommonModule } from '@angular/common';

class DzCollectionInputDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        /** The list of key codes that will trigger a chipEnd event. */
        this.separatorKeys = [ENTER, SPACE, TAB];
        this.delimiters = ['\t', '\r', '\n', ';', ',', ' '];
        // Emitted when an item is to be added.
        this.inputEnd = new EventEmitter();
        this.inputElement = this.elementRef.nativeElement;
    }
    ngOnInit() {
        this.delimitersRegex = new RegExp(`[${this.delimiters.join('')}]+`);
    }
    ngOnDestroy() {
        this.inputEnd.complete();
    }
    onKeydown(event) {
        if (event) {
            this.emitInputKeydownEnd(event);
        }
    }
    emitInputKeydownEnd(event) {
        if (this.separatorKeys.includes(event.key)) {
            if (!this.validator || this.inputElement.value?.match(new RegExp(this.validator))) {
                this.emitInputEnd({
                    input: this.inputElement,
                    value: this.inputElement.value
                });
            }
            event?.preventDefault();
        }
    }
    onPaste(event) {
        const pastedText = window['clipboardData'] ? window['clipboardData'].getData('Text') ?? '' : event?.clipboardData?.getData('text/plain') ?? '';
        let usedOutlook = false;
        // Outlook emails
        // eslint-disable-next-line no-useless-escape
        const pastedEmails = pastedText.match(new RegExp(/<[a-zA-Z0-9_\-\.@]*>/g));
        let values = [];
        if (pastedEmails?.length && this.delimiters.includes(SEMICOLON)) {
            usedOutlook = true;
            values = pastedText.split(SEMICOLON);
            pastedEmails.forEach((email) => {
                this.emitInputEnd({
                    input: this.inputElement,
                    value: email.replace(/[<>]/g, '')
                });
                values.splice(values.findIndex((val) => val.includes(email)), 1);
            });
        }
        // any other delimiter format
        if (!usedOutlook && !values.length) {
            values = pastedText.split(new RegExp(this.delimitersRegex));
        }
        values.forEach((val) => {
            const trimmedVal = val.trim();
            if (!this.validator || trimmedVal?.match(new RegExp(this.validator))) {
                this.emitInputEnd({
                    input: this.inputElement,
                    value: trimmedVal
                });
            }
        });
        event?.preventDefault();
    }
    emitInputEnd(event) {
        this.inputEnd.emit(event);
        this.clear();
    }
    clear() {
        this.inputElement.value = '';
    }
}
DzCollectionInputDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzCollectionInputDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
DzCollectionInputDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: DzCollectionInputDirective, selector: "input[dzCollectionInput]", inputs: { separatorKeys: "separatorKeys", validator: "validator", delimiters: "delimiters" }, outputs: { inputEnd: "inputEnd" }, host: { listeners: { "keydown": "onKeydown($event)", "paste": "onPaste($event)" }, classAttribute: "dz-collection-input" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzCollectionInputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[dzCollectionInput]',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        class: 'dz-collection-input'
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { separatorKeys: [{
                type: Input
            }], validator: [{
                type: Input
            }], delimiters: [{
                type: Input
            }], inputEnd: [{
                type: Output
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }] } });

class DzCollectionInputModule {
}
DzCollectionInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzCollectionInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DzCollectionInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzCollectionInputModule, declarations: [DzCollectionInputDirective], imports: [CommonModule], exports: [DzCollectionInputDirective] });
DzCollectionInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzCollectionInputModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzCollectionInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DzCollectionInputDirective],
                    imports: [CommonModule],
                    exports: [DzCollectionInputDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DzCollectionInputDirective, DzCollectionInputModule };
